import React from 'react'
import { styled } from 'tamagui'

import { Text } from '@newComponents/Text'

export const InlineCode = styled(Text, {
  tag: 'code',
  size: '$5',
  backgroundColor: '$backgroundHover',
  borderRadius: '$2',
  paddingHorizontal: '$1.5',
  paddingVertical: '$1',
  style: {
    fontFamily: 'monospace',
  },
})
